<template>
   <PrivacyAgreement/>
   <!-- <UserAgreement/> -->

   <!-- <Service/> -->
  <!-- <AboutUs/> -->
  <!-- <LaChine /> -->
   <!-- <CommonProblem /> -->
   <!-- <PublicNumber /> -->
   <!-- <UsingTutorials /> -->
  
  <!-- <ReceiveTimes  /> -->
  <!-- <GoodReviews /> -->
</template>

<script>
//公众号
import PublicNumber from './components/view/PublicNumber.vue'
//用户协议
import UserAgreement from './components/view/UserAgreement.vue'
//邀新有礼
import LaChine from './components/view/LaChines.vue'
//常见问题
import CommonProblem from './components/view/CommonProblem.vue'
//领取次数
import ReceiveTimes from './components/view/ReceiveTimes.vue'
//好评有礼
import GoodReviews from './components/view/GoodReviews.vue'
//关于我们
import AboutUs from './components/view/AboutUs.vue'
//隐私协议
import PrivacyAgreement from './components/view/PrivacyAgreement.vue'
//服务协议
import Service from './components/view/Service.vue'
export default {
  name: 'App',
  components: {
    ReceiveTimes,
    GoodReviews,
    CommonProblem,
    AboutUs,
    PrivacyAgreement,
    LaChine,
    Service,
    UserAgreement,
    PublicNumber
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  
}
</style>
